import { register } from './register';
import { translations, countries } from './translations';
import { BrandConfig } from '@whitehatgaming/shared';

export const brandConfig: BrandConfig = {
  id: 91,
  loqateKey: 'WC78-EX93-PU33-XG17',
  licensee: 'whitezip',
  name: 'Spinstation',
  displayName: 'Spinstation',
  path: 'spinstation',
  register: register,
  translations: {
    translations: translations,
    countries: countries
  },
  supportEmail: 'support@spinstation.app',
  languages: ['en', 'de', 'fi', 'no'],

  payNPlay: true,
  payNPlayContactCapture: {
    email: false,
    phone: false
  },
  logoUrl: 'assets/logo.png',
  customization: {
    playPageConfig: {
      logoDisplayed: true,
      miniCashierEnabled: true,
      quickDepositEnabled: true,
    }
  },
  routesRedirectedToLegacy: ['logout'],
};
